import React, { Fragment } from "react";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import AdministrationHeader from "../../components/header-components/AdministrationHeader";
import ReportingTab from "./ReportingTab";

const ReportingJobsPage = () => {
  return (
    <Fragment>
      <AdministrationHeader
        title="Configuration"
        className="text-text-3"
        icon={icon({ name: "wrench", style: "light" })}
        showPeriodSelector={false}
      />
      <div className="text-left flex flex-auto flex-col ml-10 mt-6 border-solid border-border">
        <ReportingTab />
      </div>
    </Fragment>
  );
};

export default ReportingJobsPage;
